import { useState, useEffect, useCallback } from 'react';
import { fetchExhibitionLots } from '../utils/api';

/**
 * Fetches all lots currently in exhibition across active auctions.
 * @param {number} [dbIndex]
 */
export function useShowroom(dbIndex) {
  const [lots, setLots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchExhibitionLots(dbIndex);
      setLots(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [dbIndex]);

  useEffect(() => { load(); }, [load]);

  return { lots, loading, error, refetch: load };
}
